'use client';
import Button from '@/components/base/button/button';
import Spinner from '@/components/base/spinner/spinner';
import type { FallbackProps } from 'react-error-boundary';

interface ErrorFallbackViewProps extends FallbackProps {
  message: string;
  btnText: string;
}

export const ErrorFallbackView = ({
  btnText,
  message,
}: ErrorFallbackViewProps) => {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-s">
      <Spinner size="icon-l" />
      <div className=" flex flex-col items-center">
        <p className="ml-2 px-s">{message}</p>
        <Button
          variant="primary"
          size="small"
          onClick={() => {
            window.location.reload();
          }}
        >
          {btnText}
        </Button>
      </div>
    </div>
  );
};
